// صفحه فراموشی رمز (فرانت‌اند)
// قرارداد مورد انتظار با بک‌اند:
// POST /api/password-reset/  body: { phone: "+98912..." }
// پاسخ نمونه (موفق): { success: true, message: "...", new_password?: "..." }
// توجه: ارسال پیامک (ارسال به https://edge.ippanel.com/v1/api/send) و استفاده از هدر
// Authorization: YOUR_TOKEN_HERE و Content-Type: application/json باید در بک‌اند Django شما انجام شود.

import React, { useState } from "react";
import API from "../utils/api";
import logo from '../karuncup.svg';
import TextField from "@mui/material/TextField";
import { styled } from '@mui/material/styles';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";

const CssTextField = styled(TextField)({
  '& label': {
    color: '#FFFF',
    fontSize: '18px',
  },
  '& .MuiFormHelperText-root': {
    color: '#FFFF',
  },
  '& label.Mui-focused': {
    color: '#A0AAB4',
  },
  '& .MuiInputBase-root': {
    color: '#FFFF',
    fontSize: '18px',
    fontFamily: 'inherit',
    border: '1px solid #65a30d',
    borderColor: '#65a30d',
    borderRadius: '8px',
  },
  '& .MuiInputBase-input': {
    textAlign: 'right',
  },
});

const RESET_API = "/api/password-reset/"; // <-- بروز رسانی شود بر اساس API بک‌اند شما

const ForgotPassword = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const normalizePhone = (value) => {
    // حذف فاصله‌ها و '-' و پرانتزها
    let v = value.replace(/[\s\-()]/g, "");
    // اگر با 0 شروع شده (0912...) تبدیل به +98
    if (/^0?9\d{9}$/.test(v)) {
      if (v.startsWith("0")) v = v.slice(1);
      return "+98" + v;
    }
    // اگر +98... یا 98... وارد شد
    if (/^(?:\+98|98)9\d{9}$/.test(v)) {
      if (v.startsWith("98")) v = "+" + v;
      return v;
    }
    return null;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const normalized = normalizePhone(phone);
    if (!normalized) {
      enqueueSnackbar("شماره موبایل معتبر وارد کنید (مثال: 09123456789 یا +989123456789)", { variant: "warning" });
      return;
    }

    setLoading(true);
    try {
      // ارسال به بک‌اند برای تولید رمز جدید و شروع فرایند ارسال پیامک
      const res = await API.post(RESET_API, { phone: normalized });
      const data = res.data;

      if (data && data.success) {
        enqueueSnackbar(data.message || "رمز جدید ساخته شد و پیامک ارسال خواهد شد.", {
          variant: "success",
          action: (key) => (
            <IconButton onClick={() => closeSnackbar(key)}>
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          ),
        });

        // بعضی از بک‌اندها ممکن است پیام موفقیت و جزئیات بازگردانند
        setPhone("");
      } else {
        enqueueSnackbar(data?.message || "خطا در بازنشانی رمز عبور.", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.response?.data?.message || "خطا در ارتباط با سرور.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" lang="fa" className="w-full flex justify-center my-6 px-4">
      <div className="w-full max-w-2xl p-6 sm:p-8 bg-gradient-to-tr from-slate-900 to-slate-800 border border-slate-700 rounded-2xl shadow-lg">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <img src={logo} className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg shadow-md" alt="logo" />
          <div className="text-right mt-2 sm:mt-0">
            <h2 className="text-xl sm:text-2xl font-bold text-white">بازنشانی رمز عبور</h2>
            <p className="text-slate-300 mt-1">شماره موبایل خود را وارد کنید تا رمز جدید برای شما پیامک شود.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <CssTextField
              fullWidth
              name="phone"
              label="شماره موبایل"
              placeholder="مثال: 09123456789 — شماره همراه خود را بدون فاصله وارد کنید"
              inputProps={{ 'aria-label': 'شماره موبایل' }}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              variant="standard"
              helperText="شماره موبایل باید برای دریافت پیامک قابل دسترس باشد"
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <button
              type="submit"
              disabled={loading}
              className={`w-full sm:w-auto text-center focus:outline-none text-white bg-lime-600 hover:bg-lime-500 font-medium rounded-lg text-sm px-6 py-2 ${loading ? 'opacity-60 cursor-not-allowed' : ''}`}
            >
              {loading ? 'در حال ارسال...' : 'ارسال و بازنشانی رمز'}
            </button>
            <button
              type="button"
              onClick={() => setPhone("")}
              className="w-full sm:w-auto text-sm text-slate-400 hover:text-slate-200 mt-2 sm:mt-0"
            >
              پاک کردن
            </button>
          </div>

          <div className="mt-2 text-slate-400 text-sm">
            <strong>نکته :</strong> لطفا از خاموش بودن فیلترشکن خود مطمئن باشید
          </div>

          {/* Removed development-only revealed password display */}
        </form>

        

        <div className="mt-6 text-center">
          <a href="/LogIn" className="text-sm text-lime-500 hover:underline">بازگشت به صفحه ورود</a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
